import ActionType from '../../../components/part/provider/ActionType'
import workflowServices from '../../../services/work-flow'
import { ACTION_TYPE_LIST, COMMUNICATION_TYPE_LIST, OUTPUT_DATE_FORMAT } from '../../../misc/commons'
import draggable from 'vuedraggable'
import VueTagsInput from '@johmun/vue-tags-input'
import VueDropzone from 'vue2-dropzone'
import DelegateMailModel from '../WorkflowActions/DelegateMailModel'
import ErrorModal from '../../share/ErrorModal'
import store from '../../../store'
import { COMMUNICATION_TYPE } from '../../../misc/commons'
import noti from '../../../utils/noti_toast'
import {getCommunicationTypeTitleCase} from '../../../misc/genericFunctions'
import recallServices from '../../../services/provider/recall'
import delegateServices from '../../../services/supplier/delegate'
import SupplierRecallServiceServices from '../../../services/supplier/supplier-recall'
import tinymce from 'vue-tinymce-editor'
import Vue from 'vue'
Vue.component('tinymce', tinymce)
export default {
    props: ['communicationId', 'id', 'disabledDelegate','providerCommunicationId','communicationType', 'providerEventStatus', 'completedRecall', 'isNotisphere', 'providerOrgId'],
    components: {
        ActionType,
        draggable,
        VueTagsInput,
        VueDropzone,
        DelegateMailModel,
        ErrorModal
    },
    data() {
        return {
            item: {
                email: [],
                comment: null,
                subject: null,
                OrganizationId: null,
                DelegatId: 0,
                document: [],
                recalldocuments: [],
                actionsList: [],
            },
            communicationTypeForRecall: COMMUNICATION_TYPE.RECALL,
            supplierModalKey: 0,
            viewBy: null,
            delegateModalKey: 0,
            delegatesendEmailModalKey: 0,
            actionList: [],
            actionList_Details: [],
            selectedActionId: null,
            actions: [],
            customActions: [],
            originalCustomActions: [],
            beforeEditCustomActions: '',
            supportingDoc: [],
            description: '',
            actionType: null,
            optionsAction: ACTION_TYPE_LIST,
            communicationTypeList: COMMUNICATION_TYPE_LIST,
            item1: '',
            loading: false,
            isEnable: false,
            isCheckAll: '',
            isCheckSquare1: '',
            isCheckSquare: '',
            isCheckAll1: '',
            clearCheckAll: '',
            moreLess: '',
            isExpanded: false,
            isExpanded1: false,
            isDragging: false,
            delayedDragging: false,
            info: null,
            Listitems: [],
            docitems: [],
            filesUpload: [],
            tag: '',
            autocompleteItems: [],
            debounce: null,
            emailError: '',
            domainError: '',
            commentError: '',
            loadingInitial: true,
            producFieldMetaList: [],
            products: [],
            errorList: [],
            dropzoneOptions: {
                url: '#',
                acceptedFiles: '.xlsx,.xls,.csv',
                maxFiles: 1,
                maxFilesize: 20,
                previewsContainer: false,
                autoProcessQueue: false,
            },
            isFileSelect: false,
            file: null,
            formKey: 0,
            value: [],
            valueTag: [],
            errorModalKey: 0,

            actionListFields: [
                {
                    key: 'description',
                    label: 'Description',
                    sortable: true,
                    column_classes: 'customalign-15percent',
                    row_classes: 'customalign-15percent wordbreakall',
                },
                {
                    key: 'progress',
                    label: 'Progress',
                    class: 'text-center',
                    sortable: true,
                },
            ],
            actionListFields1: [
                {
                    key: 'description',
                    label: '',
                    sortable: false,
                },
                {
                    key: 'action_type',
                    label: '',
                    class: 'text-center',
                    sortable: false,
                },
            ],
            actionList_Details_Fields: [
                {
                    key: 'email',
                    label: 'Delegate Email',
                    sortable: true,
                },
                {
                    key: 'data',
                    label: 'Response',
                    sortable: true,
                },
            ],

            providerList: [],
            delegateList: [],
            delegateList_Details: [],
            selectedProviderId: null,
            selectedDelegateId: null,
            organizationid: null,
            clicked: '',
            isShow: false,
            type: 'DELEGATE_ACTIONS',
            isMultiselect: false,
            inputs: [{ value: '' }],
            value1: null,
            value2: null,
            isCheckAllDelegate: false,
            DelegateListIds: [],
            DelegateListitems: [],
            OUTPUT_DATE_FORMAT: OUTPUT_DATE_FORMAT,
            delegateListFields: [
                {
                    key: 'select',
                    label: '',
                    sortable: false,
                },
                {
                    key: 'delegate_name',
                    label: 'Delegate Email',
                    sortable: true,
                },
                {
                    key: 'status',
                    label: 'Status',
                    sortable: false,
                },
                {
                    key: 'number_of_requests',
                    label: '# of Requests',
                    sortable: true,
                },
                {
                    key: 'emailsent_datetime',
                    label: 'Last Request',
                    sortable: true,
                },
                {
                    key: 'completed',
                    label: 'Tasks Done',
                    class: 'text-center',
                    sortable: true,
                },
            ],
            delegateList_Details_Fields: [
                {
                    key: 'description',
                    label: 'Description',
                    sortable: true,
                },
                {
                    key: 'data',
                    label: 'Response',
                    sortable: true,
                },
            ],
            DELEGATE_RECALL_STATUS: store.state.userType =='SUPPLIER'? [
                { value: null, text: 'Sent', color: '#ffc107' },
                { value: 'PENDING', text: 'Sent', color: '#ffc107' },
                { value: 'RESPONDED', text: 'Responded', color: '#28a745' },
                { value: 'DRAFT', text: 'Pending', color: '#ffc107' },
                { value: 'ERROR', text: 'Error', color: '#DC3545' },
            ] : [
                { value: 'PENDING', text: 'Sent', color: '#ffc107' },
                { value: 'RESPONDED', text: 'Responded', color: '#28a745' },
                { value: 'DRAFT', text: 'Draft', color: '#ffc107' },
                { value: 'ERROR', text: 'Error', color: '#DC3545' },
            ],
            DELEGATE_RECALL_RES_STATUS: store.state.userType =='SUPPLIER'? [
                { value: 'OPEN', text: 'Opened', color: '#ffc107' },
                { value: 'SEND', text: 'Sent', color: '#ffc107' },
                { value: 'DELIVERY', text: 'Delivered', color: '#ffc107' },
                { value: 'CLICK', text: 'Opened', color: '#28a745' },
                { value: 'DRAFT', text: 'Draft', color: '#ffc107' },
                { value: 'SEND', text: 'Pending', color: '#ffc107' },
            ] : [
                { value: 'OPEN', text: 'Opened', color: '#ffc107' },
                { value: 'SEND', text: 'Sent', color: '#ffc107' },
                { value: 'DELIVERY', text: 'Delivered', color: '#ffc107' },
                { value: 'CLICK', text: 'Click', color: '#ffc107' },
                { value: 'DRAFT', text: 'Draft', color: '#ffc107' },
                { value: null, text: 'Pending', color: '#ffc107' },
            ],
            orgType: store.state.userType,
            delegatemailModelKey: 0,
            tinyOptions: {
                height: 0,
                branding: false,
                statusbar: false,
                nonbreaking_force_tab: true,
                indentation: '30pt',
                content_style:
          'p {font-size: 16px;color: #666666;font-family: Helvetica,Arial,sans-serif;}',
                setup: function(ed) {
                    ed.on('keydown', function(evt) {
                        if (evt.keyCode == 9) {
                            ed.execCommand('mceInsertContent', false, '&emsp;&emsp;&emsp;')
                            evt.preventDefault()
                        }
                    })
                },
                menubar: '',
                plugins: ['lists  image paste help'],
                toolbar:
          'undo redo  | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent',
            },
            emailItem: {
                email_type: null,
                subject: null,
                content: null,
                parameters: null
            },
            bodyContent: null,
            admin: [],
            recall_items: null,
            dialog: false,
            subject: ''
        }
    },
    mounted() {
        this.viewBy = 'Delegate'
        let index = this?.options?.findIndex(x => x.value == 'MultipleChoice')
        if (this.orgType == 'PROVIDER') {
            if (index > -1) {
                this.options.pop()
            }
        }
    },

    watch: {
        viewBy(val) {
            if (val == 'Action') {
                this.GetRecallAction()
                this.viewBy = val
            } else if (val == 'Delegate') {
                this.GetRecallAction_DelegateListing()
                this.viewBy = val
                this.DelegateListIds = []
                this.DelegateListitems = []
                this.isCheckAllDelegate = false
            }
        },
        'actionType'(val) {

            if (val) {
                this.isMultiselect = false
                if (val === 'MultipleChoice') {
                    this.isMultiselect = true
                    this.inputs = []
                    this.inputs.push({ value: '' })
                }
            }
        },
        'actionValues'(val) {
            if (val) {
                this.isMultiselect = false
                if (val === 'MultipleChoice') {
                    this.isMultiselect = true
                }
            }
        },
    },
    computed: {
        filteredItems() {
            return this.autocompleteItems.filter((i) => {
                return i.text.toLowerCase().indexOf(this.tag.toLowerCase()) !== -1
            })
        },
        selectedActionIds: {
            get() {
                return this.Listitems.map(x => x.id)
            },
            set(ids) {
                this.Listitems = this.actions.filter(x => ids.includes(x.id))
                this.Listitems = this.Listitems.concat(this.customActions.filter(x => ids.includes(x.id)))
                if(this.Listitems.length === 0 ) {
                    this.isCheckSquare = false
                    this.isCheckAll = false
                } else if (this.Listitems.length === this.actions.length + this.customActions.length) {
                    this.isCheckSquare = false
                    this.isCheckAll = true
                } else {
                    this.isCheckSquare = true
                    this.isCheckAll = false
                }
            }
        },
        selectionSupportingMaterialIds: {
            get() {
                return this.docitems.map(x => x.fileName + x.extension)
            },
            set(names) {
                this.docitems = this.supportingDoc.filter(x => names.includes(x.fileName + x.extension))
                if (this.docitems.length === 0) {
                    this.isCheckAll1 = false
                    this.isCheckSquare1 = false
                } else if (this.docitems.length === this.supportingDoc.length) {
                    this.isCheckAll1 = true
                    this.isCheckSquare1 = false
                } else {
                    this.isCheckAll1 = false
                    this.isCheckSquare1 = true
                }
            }
        }
    },
    created() {
        this.$emit('onReLoadCommunicationData')
        this.$emit('onReLoadHistoryData')
        workflowServices.getCommunicationSummaryById(this.communicationId,this.providerCommunicationId,this.communicationType).then((resp) => {
            this.item1 = resp.data.d
        })
        this.getEmailSubjectByType(this.type)
        this.getDelegates()
        this.getRecallSummaryById()
        this.getUserData()
        if(this.orgType == 'NOTISPHERE') {
            const filteredFields = this.delegateListFields.filter(field => field.key !== 'select')
            this.delegateListFields = filteredFields
        }
    },
    methods: {
        getUserData() {
            if (this.$store.state.user != '') {
                var userData = this.$store.state.user
                this.admin.name = userData.fname + ' ' + userData.lname
                this.admin.email = userData.email
                this.admin.title = userData.title
                this.admin.companyname = userData.org_name
                this.admin.phoneno = userData.phone ?? ''
                this.admin.userSite = userData.userSite ?? ''
            }
            else {
                this.admin.name = ''
                this.admin.email = ''
                this.admin.title = ''
                this.admin.companyname = ''
                this.admin.phoneno = ''
                this.admin.userSite = ''
            }
        },
        getRecallSummaryById() {
            if (this.orgType == 'SUPPLIER') {
                SupplierRecallServiceServices.getCommunicationSummaryById(this.communicationId).then(resp => {
                    this.recall_items = resp.data.d
                    this.getEmail('DELEGATE_REMINDER_EMAIL')
                })
            }
            if (this.orgType == 'PROVIDER') {
                recallServices.getRecallSummaryById(this.communicationId, this.providerCommunicationId).then(resp => {
                    if (resp.error) {
                        this.$router.push({ name: 'prov_Recall' })
                    } else {
                        this.recall_items = resp.data.d
                        this.getEmail('DELEGATE_REMINDER_EMAIL')
                    }
                })
            }
        },
        getEmail(type) {
            this.emailError = ''
            this.options = []
            this.valueTag = []
            this.value = []
            this.domainError = ''
            this.selectedDelegateId = ''
            this.isShowToolbarOptions = 'true'
            this.filesUpload = []
            if (this.orgType == 'SUPPLIER') {
                delegateServices.getSupplierInformationEmail(type).then(resp => {
                    this.subject = resp.data.d.subject
                    if (!resp.error) {
                        if (this.recall_items == null) {
                            SupplierRecallServiceServices.getCommunicationSummaryById(this.communicationId).then(resp1 => {
                                if (!resp1.error) {
                                    this.recall_items = resp1.data.d
                                }
                            })
                        }
                        this.emailItem = resp.data.d
                        this.emailItem.content=resp.data.d.content.replaceAll('${CommunicationType}', this.communicationType)
                        var bodyReplace1 = /<body.*?>([\s\S]*)<\/body>/.exec(resp.data.d.content.replace('${ProviderUserName}', this.$store.state.user.full_name).replace('${ProviderRole}', this.$store.state.user.role).replace('${ProviderName}', this.recall_items == null ? this.$store.state.user.org_name : this.recall_items.supplier_name).replace('${EventName}', this.recall_items == null ? '' : this.recall_items?.name).replace('${Comments}', '')
                            .replace('${CommunicationContent}', '').replaceAll('${displayOld}', 'block !important')
                        )[1]
                        if (this.admin.title == undefined || this.admin.title == null) {
                            bodyReplace1 = bodyReplace1.replace('<p style="margin-bottom: 0px; margin-top: 0px;display: block !important;">${ProviderUserTitle}</p>', '')
                            bodyReplace1 = bodyReplace1.replace('<p style="display: block !important; margin-bottom: 0px; margin-top: 0px;">${ProviderUserTitle}</p>', '')
                            bodyReplace1 = bodyReplace1.replace('${ProviderUserTitle}', '')
                        }
                        else
                        {
                            bodyReplace1 = bodyReplace1.replace('${ProviderUserTitle}', this.admin.title)
                        }

                        if (this.admin.email == undefined || this.admin.email == null) {
                            bodyReplace1 = bodyReplace1.replace('<p style="margin-bottom: 0px; margin-top: 0px;">${ProviderUserEmailAddress}</p>', '')
                            bodyReplace1 = bodyReplace1.replace('<p style="margin-bottom: 0px; margin-top: 0px; display: block !important;">${ProviderUserEmailAddress}</p>', '')
                            bodyReplace1 = bodyReplace1.replace('${ProviderUserEmailAddress}', ' ')
                        }
                        else
                        {
                            bodyReplace1 = bodyReplace1.replace('${ProviderUserEmailAddress}', this.admin.email)
                        }

                        if (this.admin.phoneno == undefined || this.admin.phoneno == null) {
                            bodyReplace1 = bodyReplace1.replace('<p style="margin-bottom: 0px; margin-top: 0px;">${ProviderUserPhoneNumber}</p>', '')
                            bodyReplace1 = bodyReplace1.replace('<p style="margin-bottom: 0px; margin-top: 0px; display: block !important;">${ProviderUserPhoneNumber}</p>', '')
                            bodyReplace1 = bodyReplace1.replace('${ProviderUserPhoneNumber}', ' ')
                        }
                        else
                        {
                            var x1 = this.admin.phoneno.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/)
                            var newvalue1 = !x1[2] ? x1[1] :  x1[1] + '-' + x1[2] + (x1[3] ? '-' + x1[3] : '')
                            bodyReplace1 = bodyReplace1.replace('${ProviderUserPhoneNumber}', newvalue1)
                        }
                        // bodyReplace1 = bodyReplace1.replace('${CommunicationType}', this.recall_items.communicationType)
                        bodyReplace1 = bodyReplace1.replaceAll('<p style="display: block !important;"><br></p>', '')
                        this.bodyContent = bodyReplace1.replace('${EventName}', this.recall_items == null ? '' : this.recall_items?.name)
                        this.bodyContent = this.bodyContent.replace('<span id="repTxt" style="display: block', '<span id="repTxt" style="display: inline-block')
                    }
                })
            }
            if (this.orgType == 'PROVIDER') {
                recallServices.getEmail(type).then(resp => {
                    if (!resp.error) {
                        this.subject = resp.data.d.subject
                        this.emailItem = resp.data.d
                        this.emailItem.content=resp.data.d.content.replaceAll('${CommunicationType}',getCommunicationTypeTitleCase(this.communicationType,this.item1.type))
                        var bodyReplace = /<body.*?>([\s\S]*)<\/body>/.exec(resp.data.d.content.replace('${ProviderUserName}', this.$store.state.user.full_name).replace('${ProviderRole}', this.$store.state.user.role).replace('${ProviderName}', this.$store.state.user.org_name).replace('${SupplierName}', this.recall_items == null ? '' : this.recall_items.supplier_name).replace('${EventName}', this.recall_items == null ? '' : this.recall_items.recallsitecount > 1 ? this.recall_items.communicationName + ' - ' + this.recall_items.recallsitename : this.recall_items.communicationName).replace('${Comments}', '')
                            .replace('${CommunicationContent}', '').replaceAll('${displayOld}', 'block !important')
                        )[1]
                        if (this.admin.title == undefined || this.admin.title == null) {
                            bodyReplace = bodyReplace.replace('<p style="margin-bottom: 0px; margin-top: 0px;display: block !important;">${ProviderUserTitle}</p>', '')
                            bodyReplace = bodyReplace.replace('<p style="display: block !important; margin-bottom: 0px; margin-top: 0px;">${ProviderUserTitle}</p>', '')
                            bodyReplace = bodyReplace.replace('${ProviderUserTitle}', '')
                        }
                        else
                        {
                            bodyReplace = bodyReplace.replace('${ProviderUserTitle}', this.admin.title)
                        }

                        if (this.admin.email == undefined || this.admin.email == null) {
                            bodyReplace = bodyReplace.replace('<p style="margin-bottom: 0px; margin-top: 0px;">${ProviderUserEmailAddress}</p>', '')
                            bodyReplace = bodyReplace.replace('<p style="margin-bottom: 0px; margin-top: 0px; display: block !important;">${ProviderUserEmailAddress}</p>', '')
                            bodyReplace = bodyReplace.replace('${ProviderUserEmailAddress}', ' ')
                        }
                        else
                        {
                            bodyReplace = bodyReplace.replace('${ProviderUserEmailAddress}', this.admin.email)
                        }

                        if (this.admin.phoneno == undefined || this.admin.phoneno == null) {
                            bodyReplace = bodyReplace.replace('<p style="margin-bottom: 0px; margin-top: 0px;">${ProviderUserPhoneNumber}</p>', '')
                            bodyReplace = bodyReplace.replace('<p style="margin-bottom: 0px; margin-top: 0px; display: block !important;">${ProviderUserPhoneNumber}</p>', '')
                            bodyReplace = bodyReplace.replace('${ProviderUserPhoneNumber}', ' ')
                        }
                        else
                        {
                            var x = this.admin.phoneno.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/)
                            var newvalue = !x[2] ? x[1] :  x[1] + '-' + x[2] + (x[3] ? '-' + x[3] : '')
                            bodyReplace = bodyReplace.replace('${ProviderUserPhoneNumber}', newvalue)
                        }

                        bodyReplace = bodyReplace.replace('${EventName}', this.recall_items.communicationName)
                        bodyReplace = bodyReplace.replace('${SupplierName}', this.recall_items.supplier_name)
                        bodyReplace = bodyReplace.replaceAll('<p style="display: block !important;"><br></p>', '')
                        this.bodyContent = bodyReplace.replace('${EventName}', this.recall_items == null ? '' : this.recall_items.recallsitecount > 1 ? this.recall_items.communicationName + ' - ' + this.recall_items.recallsitename : this.recall_items.communicationName)
                        this.bodyContent = this.bodyContent.replace('<span id="repTxt" style="display: block', '<span id="repTxt" style="display: inline-block')
                    }
                })
            }
        },
        add(index) {
            let isValid = true
            let vakl = this.value1
            this.inputs.filter(function (elem) {
                if (elem.value == vakl) {
                    isValid = false
                }
            })
            if (isValid) {
                if (this.value1 != '' && this.value1 != null) {
                    this.inputs.push({ value: this.value1 })
                    this.value1 = null
                }
            }
            else {
                if (this.value1 == null) {
                    return ''
                }
                else {
                    this.value1 = null
                    noti.error('Error', 'Duplicate values cannot be entered.')
                    return ''
                }

            }
        },
        remove(index) {
            this.inputs.splice(index, 1)
        },
        handleFiles() {
            this.onModalComplete(this.$refs.filesInput)
        },
        onCompleted() {
            if (this.viewBy == 'Action') {
                this.GetRecallAction()
            } else if (this.viewBy == 'Delegate') {
                this.GetRecallAction_DelegateListing()
            }
        },
        FetchEmailList() {
            this.GetRecallAction_DelegateListing()
        },
        ResetDelegateSelectedData() {
            this.DelegateListIds = []
            this.DelegateListitems = []
            this.isCheckAllDelegate = false
        },
        getEmailSubjectByType(type){
            workflowServices.getEmail(type,this.communicationType).then(resp => {
                if (!resp.error) {
                    this.item.subject = resp.data.d.subject.replace('${TitleCaseCommunicationType}',getCommunicationTypeTitleCase(this.communicationType,this.item1.type))
                }
            })
        },
        CheckDuplicateAction() {
            let duplicateCheck = []
            let duplicateCheckNew = []
            this.actions.filter((x) => {
                duplicateCheck.push(x.description)
            })
            this.customActions.filter((x) => {
                duplicateCheck.push(x.description)
            })
            let isError = false
            for (let i = 0; i < duplicateCheck.length; ++i) {
                if(!duplicateCheckNew.includes(duplicateCheck[i]))
                {
                    duplicateCheckNew.push(duplicateCheck[i])
                }
                else
                {
                    isError =  true
                }
            }
            return !isError
        },
        removeAction(item){
            this.customActions = this.customActions.filter(x => x.description != item.description)
            let formData = new FormData()
            formData.append('id', this.communicationId)
            formData.append('communicationType', this.communicationType)
            if(this.customActions.length == 0)
            {
                formData.append('actions[' + 0 + '].actionType', 'action_type')
                formData.append('actions[' + 0 + '].description', 'description')
                formData.append('actions[' + 0 + '].id', 0)
                formData.append('actions[' + 0 + '].is_internal_action', 'is_internal_action')
            }
            else
            {
                this.customActions.forEach((x, j) => {
                    formData.append('actions[' + j + '].actionType', x.action_type)
                    formData.append('actions[' + j + '].description', x.description)
                    formData.append('actions[' + j + '].id', x.id == null ? 0 : x.id)
                    formData.append('actions[' + j + '].is_internal_action', x.is_internal_action == undefined ? 0 :x.is_internal_action)
                })
            }
            workflowServices.addCustomListActions(formData).then(res => {
                if (res.error) {
                    this._showToast(res.error.message, { variant: 'warning' })
                }
                else{
                    this.inputs = []
                    this.inputs.push({ value: '' })
                }
            })
        },
        EditAction(item) {
            let isValid = this.CheckDuplicateAction()
            if(!isValid)
            {
                noti.error('Error', 'Duplicate values cannot be entered.')
            }
            else
            {
                let duplicateCheck = []
                this.actions.filter((x) => {
                    duplicateCheck.push(x.description)
                })
                this.originalCustomActions.filter((x) => {
                    if(x.description != item.description)
                    {
                        duplicateCheck.push(x.description)
                    }
                })
                if(duplicateCheck.includes(item.description))
                {
                    noti.error('Error', 'Duplicate values cannot be entered.')
                }
                else
                {
                    this.customActions = this.customActions.map((x) => {
                        x.IsEditable = false
                        return {
                            ...x,
                        }
                    })
                    this.beforeEditCustomActions = item.description
                    this.customActions = this.customActions.map((x, index) => {
                        if(x.description == item.description)
                        {
                            x.IsEditable = true
                        }
                        return {
                            ...x,
                        }
                    })
                }
            }
        },
        SaveEditAction(item) {
            let duplicateCheck = []
            this.originalCustomActions.filter((x) => {
                if(x.description != this.beforeEditCustomActions)
                {
                    duplicateCheck.push(x.description)
                }
            })
            if(duplicateCheck.includes(item.description))
            {
                noti.error('Error', 'Duplicate values cannot be entered.')
            }
            else
            {
                let formData = new FormData()
                for (let i = 0; i < this.originalCustomActions.length; ++i) {
                    if(this.originalCustomActions[i].description == this.beforeEditCustomActions)
                    {
                        formData.append('id', this.communicationId)
                        formData.append('communicationType', this.communicationType)
                        formData.append('actions[' + i + '].actionType', item.action_type)
                        formData.append('actions[' + i + '].description', item.description)
                        formData.append('actions[' + i + '].id', item.id)
                        if(item.action_type == 'MultipleChoice')
                        {
                            let cn = 0
                            if(item.actionValues != undefined)
                            {
                                item.actionValues.forEach((o, k) => {
                                    formData.append('actions[' + i + '].actionValues[' + k + '].value', o.value)
                                    cn = k + 1
                                })
                            }
                            if(this.value2 != null && this.value2 != undefined && this.value2 != '')
                            {
                                formData.append('actions[' + i + '].actionvalues[' + cn + '].value', this.value2)
                                this.value2 = null
                            }
                        }
                        formData.append('actions[' + 0 + '].is_internal_action', item.is_internal_action)
                    }
                    else
                    {
                        formData.append('id', this.communicationId)
                        formData.append('communicationType', this.communicationType)
                        formData.append('actions[' + i + '].actionType', this.originalCustomActions[i].action_type)
                        formData.append('actions[' + i + '].description', this.originalCustomActions[i].description)
                        formData.append('actions[' + i + '].id', this.originalCustomActions[i].id)
                        if(this.originalCustomActions[i].action_type == 'MultipleChoice')
                        {
                            if(this.originalCustomActions[i].actionValues != undefined)
                            {
                                this.originalCustomActions[i].actionValues.forEach((o, k) => {
                                    formData.append('actions[' + i + '].actionValues[' + k + '].value', o.value)
                                })
                            }
                        }
                        formData.append('actions[' + 0 + '].is_internal_action', this.originalCustomActions[i].is_internal_action)
                    }
                }
                workflowServices.addCustomListActions(formData).then(res => {
                    if (res.error) {
                        this._showToast(res.error.message, { variant: 'warning' })
                    }
                    else
                    {
                        workflowServices.getProviderActionDetail(this.communicationId, this.$store.state.orgId,this.providerCommunicationId,this.communicationType)
                            .then((res) => {
                                this.getInternalAction()
                                let cusList = res.data.d.filter(x => x.isSelfAdded == true).map((x) => {
                                    x.IsEditable = false
                                    return {
                                        ...x,
                                    }
                                })
                                this.inputs = []
                                this.inputs.push({ value: '' })
                                for(let i=0; i <= cusList.length -1; i++)
                                {
                                    this.Listitems.forEach((x, j) => {
                                        if(x.description == cusList[i].description)
                                        {
                                            x.id = cusList[i].id
                                        }
                                    })
                                    for(let j=0; j <= this.customActions.length -1; j++)
                                    {
                                        if (this.customActions[j].description == cusList[i].description) {
                                            this.customActions[j].id = cusList[i].id
                                        }
                                    }
                                }
                                this.originalCustomActions = this.customActions
                            })
                    }
                })
            }
        },
        removeEdit(item, index, data) {
            item.splice(index, 1)
            if (item.length == 0) {
                data.actionValues.push({ value: null })
            }
        },
        AddEditAction(item, status) {
            let isValid = true
            let vakl = this.value2
            item.filter(function (elem) {
                if (elem.value == vakl) {
                    isValid = false
                }
            })
            if (isValid) {
                if (this.value2 != '' && this.value2 != null) {
                    item.push({ value: this.value2 })
                    this.value2 = null
                }
            }
            else {
                if (this.value2 == null) {
                    return ''
                }
                else {
                    this.value2 = null
                    noti.error('Error', 'Duplicate values cannot be entered.')
                    return ''
                }

            }
        },
        SaveAction(item) {
            let duplicateCheck = []
            this.customActions.filter((x) => {
                duplicateCheck.push(x.description)
            })
            this.originalCustomActions.filter((x) => {
                if(x.description != this.beforeEditCustomActions)
                {
                    duplicateCheck.push(x.description)
                }
            })
            if(duplicateCheck.includes(item.description))
            {
                noti.error('Error', 'Duplicate values cannot be entered.')
            }
            else
            {
                let formData = new FormData()
                formData.append('id', this.communicationId)
                formData.append('communicationType', this.communicationType)
                let isError = false
                for (let i = 0; i < this.customActions.length; ++i) {
                    if (this.customActions[i].action_type == 'MultipleChoice') {
                        let Arr = []
                        let DupCkList = []
                        if (this.value2 != null && this.value2 != undefined && this.value2 != '') {
                            DupCkList.push(this.value2)
                        }
                        for (let index = 0; index < this.customActions[i].actionValues.length; ++index) {
                            if (this.customActions[i].actionValues[index].value != '' && this.customActions[i].actionValues[index].value != null) {
                                Arr.push(this.customActions[i].actionValues[index])
                            }
                            if (DupCkList.includes(this.customActions[i].actionValues[index].value)) {
                                if (this.customActions[i].actionValues[index].value == this.value2) {
                                    this.value2 = null
                                }
                                isError = true
                                noti.error('Error', 'Duplicate values cannot be entered.')
                            }
                            if (this.customActions[i].actionValues[index].value != '') {
                                DupCkList.push(this.actions[i].actionValues[index].value)
                            }
                        }
                        this.customActions[i].actionValues = []
                        this.customActions[i].actionValues = Arr
                        if (isError) {
                            return ''
                        }
                    }
                    if (this.customActions[i].action_type == 'MultipleChoice' && this.customActions[i].actionValues.length == 1 && this.customActions[i].actionValues[0].value == '' && (this.value2 == null || this.value2 == undefined || this.value2 == '')) {
                        isError = true
                        noti.error('Error', 'Please add at least one option.')
                        break
                    }
                    if (this.customActions[i].action_type == 'MultipleChoice' && this.value2 != null && this.value2 != undefined) {

                        let isValid = true
                        let vakl = this.value2
                        this.customActions[i].actionValues.filter(function (elem) {
                            if (vakl != '' && elem.value == vakl) {
                                isValid = false
                            }
                        })
                        if (isValid) {
                            if (this.value2 != '' && this.value2 != null) {
                                this.customActions[i].actionValues.push({ text: null, value: this.value2 })
                                this.value2 = null
                            }
                            else {
                                let Arr = []
                                for (let index = 0; index < this.customActions[i].actionValues.length; ++index) {
                                    if (this.customActions[i].actionValues[index].value != '' && this.customActions[i].actionValues[index].value != null) {
                                        Arr.push(this.customActions[i].actionValues[index])
                                    }
                                }
                                if (Arr.length == 0) {
                                    isError = true
                                    Arr.push({ value: null })
                                    this.customActions[i].actionValues.push({ value: null })
                                    noti.error('Error', 'Please add at least one option.')
                                    break
                                }
                                this.customActions[i].actionValues = []
                                this.actions[i].actionValues = Arr
                            }
                        }
                        else {
                            isError = true
                            this.value2 = null
                            noti.error('Error', 'Duplicate values cannot be entered.')
                            break
                        }
                    }
                }
                if(this.customActions.length == 0)
                {
                    formData.append('actions[' + 0 + '].actionType', 'action_type')
                    formData.append('actions[' + 0 + '].description', 'description')
                    formData.append('actions[' + 0 + '].id', 0)
                    formData.append('actions[' + 0 + '].is_internal_action', 'is_internal_action')
                }
                else
                {
                    this.customActions.forEach((x, j) => {
                        formData.append('actions[' + j + '].actionType', x.action_type)
                        formData.append('actions[' + j + '].description', x.description)
                        if(x.action_type == 'MultipleChoice')
                        {
                            if(x.actionValues != undefined)
                            {
                                x.actionValues.forEach((o, k) => {
                                    formData.append('actions[' + j + '].actionValues[' + k + '].value', o.value)
                                })
                            }
                        }
                        formData.append('actions[' + j + '].id', x.id == null ? 0 : x.id)
                        formData.append('actions[' + j + '].is_internal_action', x.is_internal_action == undefined ? 0 :x.is_internal_action)
                    })
                }
                workflowServices.addCustomListActions(formData).then(res => {
                    if (res.error) {
                        this._showToast(res.error.message, { variant: 'warning' })
                    }
                    else{
                        this.inputs = []
                        this.inputs.push({ value: '' })
                    }
                })
                this.customActions = this.customActions.map((x) => {
                    x.IsEditable = false
                    return {
                        ...x,
                    }
                })
                this.originalCustomActions = this.customActions
            }
        },
        addAction() {
            let valid = true
            if(this.description == '' && this.actionType == null)
            {
                let formData = new FormData()
                formData.append('id', this.communicationId)
                formData.append('communicationType', this.communicationType)
                let isError = false
                for (let i = 0; i < this.customActions.length; ++i) {
                    if (this.customActions[i].action_type == 'MultipleChoice') {
                        let Arr = []
                        let DupCkList = []
                        if (this.value2 != null && this.value2 != undefined && this.value2 != '') {
                            DupCkList.push(this.value2)
                        }
                        for (let index = 0; index < this.customActions[i].actionValues.length; ++index) {
                            if (this.customActions[i].actionValues[index].value != '' && this.customActions[i].actionValues[index].value != null) {
                                Arr.push(this.customActions[i].actionValues[index])
                            }
                            if (DupCkList.includes(this.customActions[i].actionValues[index].value)) {
                                if (this.customActions[i].actionValues[index].value == this.value2) {
                                    this.value2 = null
                                }
                                isError = true
                                noti.error('Error', 'Duplicate values cannot be entered.')
                            }
                            if (this.customActions[i].actionValues[index].value != '') {
                                DupCkList.push(this.customActions[i].actionValues[index].value)
                            }
                        }
                        this.customActions[i].actionValues = []
                        this.customActions[i].actionValues = Arr
                        if (isError) {
                            return ''
                        }
                    }
                    if (this.customActions[i].action_type == 'MultipleChoice' && this.customActions[i].actionValues.length == 1 && this.customActions[i].actionValues[0].value == '' && (this.value2 == null || this.value2 == undefined || this.value2 == '')) {
                        isError = true
                        noti.error('Error', 'Please add at least one option.')
                        break
                    }
                    if (this.customActions[i].action_type == 'MultipleChoice' && this.value2 != null && this.value2 != undefined) {

                        let isValid = true
                        let vakl = this.value2
                        this.customActions[i].actionValues.filter(function (elem) {
                            if (vakl != '' && elem.value == vakl) {
                                isValid = false
                            }
                        })
                        if (isValid) {
                            if (this.value2 != '' && this.value2 != null) {
                                this.customActions[i].actionValues.push({ text: null, value: this.value2 })
                                this.value2 = null
                            }
                            else {
                                let Arr = []
                                for (let index = 0; index < this.customActions[i].actionValues.length; ++index) {
                                    if (this.customActions[i].actionValues[index].value != '' && this.customActions[i].actionValues[index].value != null) {
                                        Arr.push(this.customActions[i].actionValues[index])
                                    }
                                }
                                if (Arr.length == 0) {
                                    isError = true
                                    Arr.push({ value: null })
                                    this.customActions[i].actionValues.push({ value: null })
                                    noti.error('Error', 'Please add at least one option.')
                                    break
                                }
                                this.customActions[i].actionValues = []
                                this.customActions[i].actionValues = Arr
                            }
                        }
                        else {
                            isError = true
                            this.value2 = null
                            noti.error('Error', 'Duplicate values cannot be entered.')
                            break
                        }
                    }
                }
                this.customActions.forEach((x, j) => {
                    formData.append('actions[' + j + '].actionType', x.action_type)
                    formData.append('actions[' + j + '].description', x.description)
                    formData.append('actions[' + j + '].actionValues', x.actionValues)
                    formData.append('actions[' + j + '].id', x.id)
                    if(x.action_type == 'MultipleChoice')
                    {
                        if(x.actionValues != undefined)
                        {
                            x.actionValues.forEach((o, k) => {
                                formData.append('actions[' + j + '].actionValues[' + k + '].value', o.value)
                            })
                        }
                    }
                    formData.append('actions[' + j + '].is_internal_action', x.is_internal_action)
                })
                workflowServices.addCustomListActions(formData).then(res => {
                    if (res.error) {
                        this._showToast(res.error.message, { variant: 'warning' })
                    }
                    else{
                        this.inputs = []
                        this.inputs.push({ value: '' })
                        this.originalCustomActions = this.customActions
                    }
                })
            }
            else
            {
                let descriptionobj = this.description
                let actionTypeobj = this.actionType
                this.$refs['observerAddAction'].validate().then(isValid => {
                    if (isValid) {
                        var action = this.actions.filter(x => x.description === descriptionobj)
                        var customActions = this.customActions.filter(x => x.description === descriptionobj)
                        if (action.length > 0 || customActions.length > 0) {
                            noti.error('Error', 'You have already selected the action.')
                        } else {
                            let Arr = []
                            if (actionTypeobj == 'MultipleChoice') {
                                let DupCkList = []
                                if (this.value1 != '' && this.value1 != null) {
                                    DupCkList.push(this.value1)
                                }
                                for (let index = 0; index < this.inputs.length; ++index) {
                                    if (DupCkList.includes(this.inputs[index].value)) {
                                        if (this.inputs[index].value == this.value1) {
                                            this.value1 = null
                                        }
                                        valid = false
                                        noti.error('Error', 'Duplicate values cannot be entered.')
                                        break
                                    }
                                    if (this.inputs[index].value != '') {
                                        DupCkList.push(this.inputs[index].value)
                                    }
                                }
                                if (!valid) {
                                    return ''
                                }
                                if (this.inputs.length > 1) {
                                    if (this.value1 != '' || this.value1 != null) {
                                        this.inputs.push({ value: this.value1 })
                                        this.value1 = null
                                    }
                                }
                                else {
                                    if (this.value1 != '' || this.value1 != null) {
                                        this.inputs.push({ value: this.value1 })
                                        this.value1 = null
                                    }
                                }
                                for (let index = 0; index < this.inputs.length; ++index) {
                                    if (this.inputs.length == 1 && this.inputs[index].value == '') {
                                        if (this.value1 == '' || this.value1 == null) {
                                            valid = false
                                            noti.error('Error', 'Please add at least one option.')
                                        }
                                        else {
                                            this.inputs.push({ value: this.value1 })
                                            this.value1 = null
                                        }
                                    }
                                    if (this.inputs[index].value != '' && this.inputs[index].value != null) {
                                        Arr.push(this.inputs[index])
                                    }
                                }
                            }
                            if (actionTypeobj == 'MultipleChoice' && Arr.length == 0) {
                                this.inputs = []
                                this.inputs.push({ value: '' })
                                if (valid) {
                                    valid = false
                                    noti.error('Error', 'Please add at least one option.')
                                }
                            }
                            if (valid) {
                                this.customActions.push({
                                    id: null,
                                    description: descriptionobj,
                                    action_type: actionTypeobj,
                                    isCustomizedContent: this.isCustomizedContent,
                                    order: this.nextOrder,
                                    isCustomActionType: (this.isCustom == true || this.communicationType == this.productDisruption) ? true : false,
                                    isMultiselect: this.isMultiselect,
                                    isAllowOnlyOne: this.isAllowOnlyOne,
                                    actionValues: actionTypeobj == 'MultipleChoice' ? Arr : this.inputs,
                                    IsEditable: false,
                                    IsDelete: true,
                                    IsCustomAdded: true,
                                    checked: true
                                })
                                this.Listitems.push({
                                    id: null,
                                    description: descriptionobj,
                                    action_type: actionTypeobj,
                                    isCustomizedContent: this.isCustomizedContent,
                                    order: this.nextOrder,
                                    isCustomActionType: (this.isCustom == true || this.communicationType == this.productDisruption) ? true : false,
                                    isMultiselect: this.isMultiselect,
                                    isAllowOnlyOne: this.isAllowOnlyOne,
                                    actionValues: actionTypeobj == 'MultipleChoice' ? Arr : this.inputs,
                                    IsEditable: false,
                                    IsDelete: true,
                                    IsCustomAdded: true,
                                    checked: true
                                })
                                let formData = new FormData()
                                formData.append('id', this.communicationId)
                                formData.append('communicationType', this.communicationType)
                                this.customActions.forEach((x, j) => {
                                    formData.append('actions[' + j + '].actionType', x.action_type)
                                    formData.append('actions[' + j + '].description', x.description)
                                    formData.append('actions[' + j + '].id', x.id == null ? 0 : x.id)
                                    formData.append('actions[' + j + '].is_internal_action', x.is_internal_action == undefined ? 0 :x.is_internal_action)
                                    if(x.action_type == 'MultipleChoice')
                                    {
                                        if(x.actionValues != undefined)
                                        {
                                            x.actionValues.forEach((o, k) => {
                                                formData.append('actions[' + j + '].actionValues[' + k + '].value', o.value)
                                            })
                                        }
                                    }
                                })
                                workflowServices.addCustomListActions(formData).then(res => {
                                    if (res.error) {
                                        this._showToast(res.error.message, { variant: 'warning' })
                                    }
                                    else
                                    {
                                        workflowServices.getProviderActionDetail(this.communicationId, this.$store.state.orgId,this.providerCommunicationId,this.communicationType)
                                            .then((res) => {
                                                let cusList = res.data.d.filter(x => x.isSelfAdded == true).map((x) => {
                                                    return {
                                                        ...x,
                                                    }
                                                })
                                                this.inputs = []
                                                this.inputs.push({ value: '' })
                                                for(let i=0; i <= cusList.length -1; i++)
                                                {
                                                    this.Listitems.forEach((x, j) => {
                                                        if(x.description == cusList[i].description)
                                                        {
                                                            x.id = cusList[i].id
                                                        }
                                                    })
                                                    for(let j=0; j <= this.customActions.length -1; j++)
                                                    {
                                                        if (this.customActions[j].description == cusList[i].description) {
                                                            this.customActions[j].id = cusList[i].id
                                                        }
                                                    }
                                                }
                                            })
                                    }
                                })
                                this.customActions = this.customActions.map((x) => {
                                    if(this.description == x.description)
                                    {
                                        x.checked = true
                                    }
                                    this.isCheckAll = true
                                    return {
                                        ...x,
                                    }
                                })
                                this.originalCustomActions = this.customActions
                            }
                            requestAnimationFrame(() => {
                                this.$refs.observerAddAction.reset()
                            })
                        }
                    }
                })
                this.description = ''
                this.actionType = []
            }
        },
        onModalComplete(event) {
            this.filesUpload = event
            var len = this.supportingDoc.length
            var FilesData = ''
            if (this.filesUpload.files == undefined) {
                FilesData = this.filesUpload[0].files
            } else {
                FilesData = this.filesUpload.files
            }
            for (let i = 0; i < FilesData.length; i++) {
                if (FilesData[i].size > 10 * 1024 * 1024) {
                    this._showToast(
                        'The maximum size of the documents to be uploaded should be 10MB.',
                        { variant: 'danger', title: 'Error' }
                    )
                } else {
                    this.supportingDoc.push({
                        extension: '.' + FilesData[i].name.split('.')[1],
                        is_thumbnail: false,
                        fileName: FilesData[i].name.split('.')[0],
                        note: '',
                        path: '',
                        recallId: '',
                        fileSize: FilesData[i].size,
                        type: FilesData[i].type,
                        id: 0,
                        Ischecked: true,
                        file: FilesData[i],
                        order: len + 1,
                    })
                    this.docitems.push({
                        extension: '.' + FilesData[i].name.split('.')[1],
                        is_thumbnail: false,
                        fileName: FilesData[i].name.split('.')[0],
                        note: '',
                        path: '',
                        recallId: '',
                        fileSize: FilesData[i].size,
                        type: FilesData[i].type,
                        id: 0,
                        Ischecked: true,
                        file: FilesData[i],
                        order: len + 1,
                    })
                    len++
                }
            }
            if (this.docitems.length == 0) {
                this.isCheckAll1 = false
                this.isCheckSquare1 = false
            } else if (this.docitems.length == this.supportingDoc.length) {
                this.isCheckAll1 = false
                this.isCheckSquare1 = true
            } else if (this.docitems.length > 0) {
                this.isCheckAll1 = true
                this.isCheckSquare1 = false
            }
        },
        addSupDoc() {
            this.supplierModalKey += 1
            this.$nextTick(() => {
                this.$refs.supplierModal.forceRerenderInsert()
            })
        },

        onSelect(event) {
            this.emailError = ''
            if (event.email) {
                var exists = this.delegateList.filter((elem) => {
                    return elem.delegate_name == event.email
                })
                if (exists.length > 0) {
                    this.$refs.addDelegate.emailError =
            'Recall has already been sent to this delegate.'
                }
            }
        },
        showImportProductModal() {
            this.delegateModalKey += 1
            this.$nextTick(() => {
                this.$refs.addDelegate.forceRerender(
                    this.communicationId,
                    this.producFieldMetaList
                )
            })
        },
        handleRowClick(item) {
            this.selectedDelegateId = item.delegate_id
            this.GetRecallAction_DelegateListing_Detail()
        },
        ViewDelegateMailData(item) {
            if(this.providerEventStatus != 'COMPLETED')
            {
                if(!this.completedRecall)
                {
                    this.delegatemailModel += 1
                    this.$nextTick(() => {
                        this.$refs.delegatemailModel.forceRerenderView(
                            item,
                            this.communicationId,
                            'View',
                            this.providerCommunicationId,
                            this.communicationType,
                            this.bodyContent,
                            this.subject,
                            this.DelegateListitems
                        )
                    })
                }
            }
        },
        ViewDelegateErrorModal(item) {
            this.errorModalKey += 1
            this.$nextTick(() => {
                this.$refs.errorModal.forceRerenderView(
                    item
                )
            })
        },
        ResendDelegateMail() {
            this.delegatemailModel += 1
            if(this.recall_items != undefined && this.recall_items != null)
            {
                this.$nextTick(() => {
                    this.$refs.delegatemailModel.forceRerenderView(
                        null,
                        this.communicationId,
                        'SendMail',
                        this.providerCommunicationId == undefined ? this.$route.params.providerCommunicationId : this.providerCommunicationId,
                        this.communicationType,
                        this.bodyContent,
                        this.subject,
                        this.DelegateListitems
                    )
                })
            }
        },
        rowDelegateClick(item) {
            this.selectedDelegateId = item.delegate_id
            this.GetRecallAction_DelegateListing_Detail()
        },
        rowTableActionClick(item) {
            this.selectedActionId = item.action_id
            this.GetRecallAction_Detail()
        },
        rowClassProvider(item, type) {
            if (!item || type !== 'row') return
            if (item.delegate_id === this.selectedDelegateId) return 'table-primary'
        },
        rowClassAction(item, type) {
            if (!item || type !== 'row') return
            if (item.action_id === this.selectedActionId) return 'table-primary'
        },
        GetRecallAction() {
            workflowServices.getRecallAction_Async(this.communicationId,this.providerCommunicationId,this.communicationType, this.providerOrgId).then((resp) => {
                if (!resp.error) {
                    this.actionList = resp.data.d
                    if (
                        this.actionList &&
            this.actionList[0] &&
            this.actionList[0].action_id
                    ) {
                        this.selectedActionId = this.actionList[0].action_id
                        this.GetRecallAction_Detail()
                    }
                }
            })
        },
        GetRecallAction_Detail() {
            if (this.selectedDelegateId != null && this.selectedDelegateId != undefined && this.selectedDelegateId > 0) {
                workflowServices
                    .GetRecallAction_Detail(
                        this.communicationId,
                        this.selectedDelegateId,
                        this.selectedActionId,
                        this.providerCommunicationId,this.communicationType, this.providerOrgId
                    )
                    .then((resp) => {
                        if (!resp.error) {
                            this.actionList_Details = resp.data.d
                        }
                    })
            }
        },
        GetRecallAction_DelegateListing() {
            workflowServices
                .getRecallAction_DelegateListing(this.communicationId,this.providerCommunicationId,this.communicationType, this.providerOrgId)
                .then((resp) => {
                    if (!resp.error) {
                        this.delegateList = resp.data.d
                        if (
                            this.delegateList &&
              this.delegateList[0] &&
              this.delegateList[0].delegate_id
                        ) {
                            this.selectedDelegateId = this.delegateList[0].delegate_id
                            this.organizationid = this.delegateList[0].provider_id
                            this.GetRecallAction_DelegateListing_Detail()
                        }
                    }
                })
        },
        GetRecallAction_DelegateListing_Detail() {
            workflowServices
                .getRecallAction_DelegateListing_Detail(
                    this.communicationId,
                    this.selectedDelegateId,this.communicationType,
                    this.providerOrgId
                )
                .then((resp) => {
                    if (!resp.error) {
                        this.delegateList_Details = resp.data.d
                    }
                })
        },
        downloadDelegateStatusReport() {
            workflowServices
                .downloadProviderDelegateStausReport(this.communicationId, this.item1.communicationUID,this.providerCommunicationId,this.item1.recallsitename,this.communicationType,'xlsx', this.providerOrgId)
                .then((resp) => {})
        },
        exportDelegateStatusReportCSV() {
            workflowServices
                .downloadProviderDelegateStausReport(this.communicationId, this.item1.communicationUID,this.providerCommunicationId,this.item1.recallsitename,this.communicationType,'csv', this.providerOrgId)
                .then((resp) => {})
        },
        getInternalAction() {
            workflowServices
                .getProviderActionDetail(this.communicationId, this.$store.state.orgId,this.providerCommunicationId,this.communicationType)
                .then((res) => {
                    this.actionData = res.data.d
                    this.actions = res.data.d.filter(x => x.isSelfAdded == false).map((x, index) => {
                        return {
                            ...x,
                            order: index + 1,
                        }
                    })
                    this.customActions = res.data.d.filter(x => x.isSelfAdded == true).map((x, index) => {
                        x.order= index + 1
                        x.IsCustomAdded= true
                        x.checked= false
                        return {
                            ...x,
                        }
                    })
                    this.originalCustomActions = this.customActions
                })
        },
        getSupportingDoc() {
            workflowServices.getSupportigDoc(this.communicationId,this.communicationType).then((res) => {
                this.supportingData = res.data.d
                this.supportingDoc = res.data.d.map((x, index) => {
                    return {
                        ...x,
                        Ischecked: false,
                        order: index + 1,
                    }
                })
            })
        },
        getDelegates() {
            workflowServices
                .getDelegateEmailList(this.$store.state.orgId, true,this.communicationType)
                .then((resp) => {
                    if (!resp.error) {
                        resp.data.d.forEach((val) => {
                            this.autocompleteItems.push({
                                text: val.email,
                                is_dl: val.is_dl,
                            })
                        })
                    }
                })
        },
        createDelegate() {
            //Add for domain validation
            if (this.domainError == 'domainError') {
                return this._showToast('The email domain is not valid.', {
                    title: 'Error',
                    variant: 'danger',
                })
            }
            this.DelegatId = 1
            //Add duplicate email validation
            if (this.value.length > 1) {
                for (var i = 0; i < this.value.length; i++) {
                    for (var k = i + 1; k < this.value.length; k++) {
                        if (this.value[i].email.trim() === this.value[k].email.trim()) {
                            return (this.emailError = 'The email has been already used.')
                        }
                    }
                }
            }
            //end
            var ListAction = this.Listitems
            var Docitems = this.docitems
            if (this.value.length == 0) {
                this.emailError = 'Email is required'
            } else {
                this.emailError = ''
            }
            let index1 = 0
            let Lenth = 0
            Docitems.forEach((x, k) => {
                if (x.recallId != '') {
                    Lenth = Lenth + x.fileSize
                    index1++
                } else {
                    Lenth = Lenth + x.file.size
                }
            })
            if (Lenth > 10 * 1024 * 1024) {
                this.docitems = []
                this.isCheckAll1 = false
                this.isCheckSquare1 = false
                this.supportingDoc.forEach((x, k) => {
                    x.Ischecked = false
                })
                this._showToast(
                    'The maximum size of the documents to be uploaded should be 10MB.',
                    { variant: 'danger', title: 'Error' }
                )
            } else {
                let formData = new FormData()
                for (let k = 0; k < this.value.length; k++) {
                    if (this.value[k].is_dl)
                        formData.append('distributionlist', this.value[k].email)
                    else formData.append('emaillist', this.value[k].email)
                }
                formData.append('comment', this.item.comment)
                formData.append('subject', this.item.subject)
                ListAction.forEach((x, j) => {
                    formData.append('actions[' + j + '].actiontype', x.action_type)
                    formData.append('actions[' + j + '].description', x.description)
                    formData.append('actions[' + j + '].actionid', x.id)
                    formData.append(
                        'actions[' + j + '].isinternalaction',
                        x.is_internal_action == null || x.is_internal_action == undefined ? 0 : x.is_internal_action
                    )
                })
                let index = 0
                Docitems.forEach((x, k) => {
                    if (x.recallId != '') {
                        formData.append(
                            'recalldocuments[' + index + '].extension',
                            x.extension
                        )
                        formData.append(
                            'recalldocuments[' + index + '].documentid',
                            x.documentId
                        )
                        formData.append(
                            'recalldocuments[' + index + '].filename',
                            x.fileName
                        )
                        formData.append(
                            'recalldocuments[' + index + '].communicationId',
                            x.communicationId == '' ? null : x.communicationId
                        )
                        formData.append(
                            'recalldocuments[' + index + '].filesize',
                            x.fileSize
                        )
                        formData.append(
                            'recalldocuments[' + index + '].mimetype',
                            x.mimeType
                        )
                        formData.append('recalldocuments[' + index + '].s3path', x.s3Path)
                        formData.append(
                            'recalldocuments[' + index + '].isthumbnail',
                            x.isThumbnail
                        )
                        formData.append('recalldocuments[' + index + '].datacontent', '')
                        index++
                    } else {
                        formData.append('document', x.file)
                    }
                })
                workflowServices
                    .submitDelegate(this.communicationId, this.DelegatId, formData,this.providerCommunicationId,this.communicationType)
                    .then((resp) => {
                        if (!resp.error) {
                            this.valueTag = []
                            this.Listitems = []
                            this.actions = []
                            this.docitems = []
                            this.supportingDoc = []
                            this.isCheckAll = false
                            this.isCheckSquare = false
                            this.isCheckAll1 = false
                            this.isCheckSquare1 = false
                            this.clearCheckAll = false
                            this.item.comment = null
                            this.getEmailSubjectByType(this.type)
                            this.isExpanded = false
                            this.isExpanded1 = false
                            this.delegateclick()
                            this.getInternalAction()
                            this._showToast('Email sent successfully!')
                            this.$emit('onCompleted')
                        }
                        else{
                            if(resp.data.c=='err_valid_emailcount')
                            {
                                this._showToast('E-mails are not sent to expected all users', {
                                    variant: 'error',
                                })
                            }
                        }
                    })
            }
        },
        checkDomainValidation(tag) {
            this.domainError = ''
            workflowServices
                .getDomain(tag.email, this.$store.state.orgId,this.communicationType)
                .then((resp) => {
                    if (resp.error) {
                        this.domainError = 'domainError'
                        this.value.pop(tag)
                        return false
                    } else {
                        return true
                    }
                })
        },
        checkEmailValidation(tag) {
            if (!tag) {
                this.emailError = 'Email is required'
            } else {
                this.emailError = ''
            }
            var currentTag = tag
            if (currentTag) {
                this.$emit('onSelect', currentTag)
                const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                var b = re.test(String(tag.email.trim()).toLowerCase())
                if (!b) {
                    this._showToast('Please enter valid email address', {
                        variant: 'warning',
                    })
                }
            }
        },

        forceRerender(recallId, producFieldMetaList) {
            this.loadingInitial = true
            this.resetData()
            this.producFieldMetaList = producFieldMetaList
            this.$refs.modal.show()
            this.loadingInitial = false
        },

        resetData() {
            this.file = null
            this.isFileSelect = false
            this.producFieldMetaList = []
            this.products = []
            this.errorList = []
        },

        onClose() {
            this.$emit('onClose')
        },

        save() {
            this.createDelegate()
        },
        delegateclick() {
            this.value = []
            this.Listitems = []
            this.getInternalAction()
            this.getSupportingDoc()
            this.getEmailSubjectByType(this.type)
            this.clicked = 'true'
            this.isShow = false
            this.isCheckAll = false
            this.isCheckSquare = false
            this.isCheckAll1 = false
            this.clearCheckAll = false
            this.DelegateListIds = []
            this.DelegateListitems = []
            this.isCheckAllDelegate = false
        },
        addCheck(val) {
            if (val.length > 0) {
                this.value = []
                val.forEach((x) => {
                    if (x.is_dl == true) {
                        const tag = {
                            email: x.text,
                            is_dl: x.is_dl,
                        }
                        this.value.push(tag)
                    } else {
                        const tag = {
                            email: x.text,
                            is_dl: false,
                        }
                        this.checkEmailValidation(tag)
                        if (!this.emailError) {
                            this.value.push(tag)
                            this.checkDomainValidation(tag)
                        }
                    }
                })
                if (this.value.length > 1) {
                    var valueOriginal = this.value.length
                    var valcurrent = val.length - 1
                    const re = /^(([^<>()\\.,;:\s@"]+(\.[^<>()\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/
                    var b = re.test(String(val[valcurrent].text.trim()).toLowerCase())
                    if (b) {
                        var i = 0
                        for (i = 0; i < valueOriginal - 1; i++) {
                            if (this.value[i].email.trim() === val[valcurrent].text.trim()) {
                                this.emailError = 'The email has been already used.'
                            }
                        }
                    }
                }
            } else {
                this.value = []
                this.domainError = ''
            }
        },
        checkboxChange(item, event) {
            if (event.target.checked) {
                this.Listitems.push(item)
            } else {
                this.Listitems.forEach((item1) => {
                    if (item1.description == item.description) {
                        this.Listitems.splice(this.Listitems.indexOf(item1), 1)
                    }
                })
            }
            if (this.Listitems.length == 0) {
                this.isCheckAll = false
                this.isCheckSquare = false
            } else if (this.Listitems.length == this.actions.length) {
                this.isCheckAll = false
                this.isCheckSquare = true
            } else if (this.Listitems.length > 0) {
                this.isCheckAll = true
                this.isCheckSquare = false
            }
        },
        checkAllActions() {
            if(this.Listitems.length == this.actions.length + this.customActions.length) {
                this.Listitems = []
                this.isCheckAll = false
            } else if (this.Listitems.length > 0) {
                this.Listitems = []
                for (let item of this.actions) {
                    this.Listitems.push(item)
                }
                for (let item of this.customActions) {
                    this.Listitems.push(item)
                }
                this.isCheckAll = true
            } else {
                for (let item of this.actions) {
                    this.Listitems.push(item)
                }
                for (let item of this.customActions) {
                    this.Listitems.push(item)
                }
                this.isCheckAll = true
            }
        },
        checkAllSupportingDoc() {
            if(this.docitems.length == this.supportingDoc.length) {
                this.docitems = []
                this.isCheckAll1 = false
            } else if (this.docitems.length > 0) {
                this.docitems = []
                for (let item of this.supportingDoc) {
                    this.docitems.push(item)
                }
                this.isCheckAll1 = true
            } else {
                for (let item of this.supportingDoc) {
                    this.docitems.push(item)
                }
                this.isCheckAll1 = true
            }
        },
        supportingChange(item, event) {
            if (event.target.checked) {
                this.docitems.push(item)
            } else {
                this.docitems.forEach((item1) => {
                    if (item1.order == item.order) {
                        this.docitems.splice(this.docitems.indexOf(item1), 1)
                    }
                })
            }
            if (this.docitems.length == 0) {
                this.isCheckAll1 = false
                this.isCheckSquare1 = false
            } else if (this.docitems.length == this.supportingDoc.length) {
                this.isCheckAll1 = false
                this.isCheckSquare1 = true
            } else if (this.docitems.length > 0) {
                this.isCheckAll1 = true
                this.isCheckSquare1 = false
            }
        },
        expandMoreLess() {
            if (this.isExpanded == false) this.moreLess = 'See Less Information'
            else this.moreLess = 'See More Information'
        },
        checkboxChangeDelegate(item, event) {
            if (event.target.checked) {
                this.DelegateListitems.push(item)
            }
            else {
                this.DelegateListitems.forEach(item1 => {
                    if (item1.delegate_id == item.delegate_id) {
                        this.DelegateListitems.splice(this.DelegateListitems.indexOf(item1), 1)
                    }
                })
            }
            if (this.DelegateListitems.length == this.delegateList.length) {
                this.isCheckAllDelegate = true
            }
            else {
                this.isCheckAllDelegate = false
            }
        },
        checkboxAllChangeDelegate() {
            this.DelegateListIds = []
            this.DelegateListitems = []
            if (this.isCheckAllDelegate)
                this.delegateList.filter(item => item.status != 'RESPONDED').forEach(item => {
                    this.DelegateListitems.push(item)
                    this.DelegateListIds.push(item.delegate_id.toString())
                })
        },
    },
}
